import type { PaletteOptions } from '@mui/material';
import { PaletteColor, alpha } from '@mui/material/styles';
import { error, info, neutral, success, warning } from '../colors';
import type { Contrast } from '../index';

interface Config {
  primaryColor?: PaletteColor;
  contrast?: Contrast;
}

export const createPalette = (config: Config): PaletteOptions => {
  const { primaryColor } = config;

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[100], 0.38),
      disabledBackground: alpha(neutral[100], 0.12),
      focus: alpha(neutral[100], 0.16),
      hover: alpha(neutral[100], 0.04),
      selected: alpha(neutral[100], 0.12)
    },
    background: {
      default: '#0B0F19',
      paper: neutral[900]
    },
    divider: '#2D3748',
    error,
    info,
    mode: 'dark',
    neutral,
    border: '#2D3748',
    primary: primaryColor,
    secondary: {
      main: '#A0AEC0'
    },
    success,
    text: {
      primary: '#EDF2F7',
      secondary: '#A0AEC0',
      disabled: 'rgba(255, 255, 255, 0.48)'
    },
    warning
  };
};
